import {
  AgentDBValue,
  ChannelDataDBValue,
  ChannelDBValue,
  ConversationDBValue,
  ParticipantDBValue,
  WidgetDBValue,
} from 'utils/storage/schemas';

export enum DBStoreTypes {
  WIDGET = 'widget.state',
  CONVERSATION = 'conversation.state',
  PARTICIPANT = 'participant.information',
  AGENT = 'agent.information',
  CHANNEL = 'channel.information',
}

export interface DBStoreParams {
  key?: string;
  discriminator?: string;
}

export interface UpsertParams<V> extends DBStoreParams {
  data: V;
}

export type DBStore<V extends WebChatDBValue> = {
  upsert(params: UpsertParams<V>): Promise<void>;
  get(params: DBStoreParams): Promise<V | unknown | undefined>;
  delete(params: DBStoreParams): Promise<void>;
};

export type WebChatDBValue =
  | (WidgetDBValue | boolean)
  | (ParticipantDBValue | string)
  | (AgentDBValue | string)
  | (ChannelDBValue | ChannelDataDBValue | string | number | boolean)
  | (ConversationDBValue | boolean);
